import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import PaperIcon from './PaperIcon'
import Tooltip from './Tooltip'

const styles = theme => ({
  container: {
    marginBottom: '20px'
  }
})

const LoginButton = ({ classes, onClick }) => (
  <PaperIcon className={classes.container}>
    <Tooltip id={'login'} title={'sign in'}>
      <IconButton color='primary' onClick={() => onClick()}>
        <AccountCircleIcon />
      </IconButton>
    </Tooltip>
  </PaperIcon>
)

export default withStyles(styles)(LoginButton)



// WEBPACK FOOTER //
// ./src/components/LoginButton.js